export default {
  message: '请检查所有标注是否都已完成'
}



// WEBPACK FOOTER //
// ./src/lang/zh/task1005.js